/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import notification from "../config/notifications.config.json";
import axios from "axios";

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  loginRestAPI: string;
  headers: any;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    const srv = LoginPageServ();

    try {
      const res = await axios.post(
        `${args?.loginRestAPI}${config?.inviteEP}`,
        {
          email: args?.email,
          firstName: args?.firstName,
          lastName: args?.lastName,
          invite: args?.invite,
          role: {
            name: config?.role,
          },
        },
        {
          headers: {
            ...args?.headers,
            authentication: srv?.getToken(),
          },
        }
      );
      if (res?.data) {
        return {
          data: res?.data,
          notification: notification?.userInviteSuccess,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
